import axios from "axios";
import { handlePaginatedResponse, createPaginatedState,createPaginatedStateWithSummary } from '../helpers/paginationState';

export const state = {
    stock_receive_cart: [],
    stock_transfer_cart: [],
    direct_transfer_cart: [],
    stock_transfers: createPaginatedState(),
    save_status: false,
    filter_status: false,
    stock_transfersdetails: createPaginatedStateWithSummary(50, {
            totalStockValue: 0,
        }),
    stock_transfersdetails_data: {
        data: [],
        meta: {
            current_page: 1,
            from: 1,
            last_page: 1,
            per_page: 50,
            to: 0,
            total: 0,
        },
        isServerPaginated: true,
        summary: {
            totalStockValue: 0,
        }
    },
    current_stock_transfersdetails_filters: {
        page: 1,
        per_page: 50,
        dateto: '',
        datefrom: '',
        product: '',
        branch_id: 0
    },
    stock_transferdetails: []
};
export const getters = {
    StockTransfersData: state => state.stock_transfers.data,
    StockTransfersDataPagination: state => state.stock_transfers.meta,
    StockTransfersDataPaginated: state => state.stock_transfers.data,
    IsStockTransfersDataServerPaginated: state => state.stock_transfers.isServerPaginated,

    StockTransfersDetails: state => state.stock_transfersdetails.data,
    StockTransfersDetailsPaginated: state => state.stock_transfersdetails_data.data,
    StockTransfersDetailsPagination: state => state.stock_transfersdetails_data.meta,
    IsStockTransfersDetailsServerPaginated: state => state.stock_transfersdetails_data.isServerPaginated,
    StockTransfersDetailsSummary: state => state.stock_transfersdetails_data.summary,
    CurrentStockTransfersDetailsFilters: state => state.current_stock_transfersdetails_filters,
    StockTransferDetails: state => state.stock_transferdetails.data,
    StockTransferCart: state => state.stock_transfer_cart.data,
    DirectTransferCart: state => state.direct_transfer_cart.data,
    StockReceiveCart: state => state.stock_receive_cart.data,
    SaveStatus: state => state.save_status,
    filterStatus: state => state.filter_status,
};
export const mutations = {
    SET_SAVE_STATUS(state, newValue) {
        state.save_status = newValue
    },
    SET_TRANSFER_RECEIVE_CART(state, newValue) {
        state.stock_receive_cart = newValue
    },
    SET_STOCK_TRANSFERS(state, response) {
        handlePaginatedResponse(state.stock_transfers, response);
        
    },
    RESET_STOCK_TRANSFERS_PAGINATION(state) {
        state.stock_transfers.data = [];
        state.stock_transfers.meta = { current_page: 1, from: 1, last_page: 1, per_page: 10, to: 0, total: 0 };
        state.stock_transfers.isServerPaginated = false;
    },
    SET_STOCK_TRANSFERSDETAILS(state, response) {
        handlePaginatedResponse(state.stock_transfersdetails, response);
    },
    SET_STOCK_TRANSFERSDETAILS_DATA(state, response) {
        if (response && response.data) {
            state.stock_transfersdetails_data.data = response.data;

            if (response.summary) {
                state.stock_transfersdetails_data.summary = response.summary;
            } else {
                state.stock_transfersdetails_data.summary = { totalStockValue: 0 };
            }

            if (response.meta && response.links) {
                state.stock_transfersdetails_data.meta = response.meta;
                state.stock_transfersdetails_data.isServerPaginated = true;
            } else {
                state.stock_transfersdetails_data.meta = {
                    current_page: 1,
                    from: 1,
                    last_page: 1,
                    per_page: response.data.length || 50,
                    to: response.data.length || 0,
                    total: response.data.length || 0,
                };
                state.stock_transfersdetails_data.isServerPaginated = false;
            }
        } else {
            state.stock_transfersdetails_data.data = [];
            state.stock_transfersdetails_data.meta = { current_page: 1, from: 1, last_page: 1, per_page: 50, to: 0, total: 0 };
            state.stock_transfersdetails_data.summary = { totalStockValue: 0 };
            state.stock_transfersdetails_data.isServerPaginated = true;
        }
    },
    SET_CURRENT_STOCK_TRANSFERSDETAILS_FILTERS(state, filters) {
        state.current_stock_transfersdetails_filters = { ...state.current_stock_transfersdetails_filters, ...filters };
    },
    SET_STOCK_TRANSFER_CART(state, newValue) {
        state.stock_transfer_cart = newValue
    },
    SET_DIRECT_TRANSFER_CART(state, newValue) {
        state.direct_transfer_cart = newValue
    },
    SET_FILTER_STATUS(state, newValue) {
        state.filter_status = newValue
    },
    SET_STOCK_TRANSFERDETAILS(state, newValue) {
        state.stock_transferdetails = newValue
    },
};
export const actions = {

    // add products to lpo cart
    addToCart({ dispatch, commit }, data) {
        commit('SET_SAVE_STATUS', true)
        axios.post('stock_transfer_cart', data).then(response => {
            commit('SET_SAVE_STATUS', false)
            dispatch('fetchCart')
            if (response.status == 201) {
                let message = { 'msg': response.data.message }
                dispatch('notification/error', message, { root: true })
            }
        }).catch(() => {
            commit('SET_SAVE_STATUS', false)
            let message = { 'msg': "Failed to add Product to Cart" }
            dispatch('notification/error', message, { root: true })
        })
    },

    editCart({ dispatch, commit }, data) {
        commit('SET_SAVE_STATUS', true)
        axios.put(`stock_transfer_cart/${data.id}`, data).then(response => {
            commit('SET_SAVE_STATUS', false)
            dispatch('fetchCart')
            if (response.status == 200) {
                let message = { 'msg': "Product edited successfully" }
                dispatch('notification/success', message, { root: true })
            } else if (response.status == 201) {
                let message = { 'msg': "Failed to edit Product" }
                dispatch('notification/error', message, { root: true })
            }
        }).catch(() => {
            commit('SET_SAVE_STATUS', false)
            let message = { 'msg': "Failed to edit Product" }
            dispatch('notification/error', message, { root: true })
        })
    },

    deleteCart({ dispatch, commit }, data) {
        commit('SET_SAVE_STATUS', true)
        axios.delete(`stock_transfer_cart/${data.id}`).then(response => {
            commit('SET_SAVE_STATUS', false)
            dispatch('fetchCart')
            if (response.status == 200) {
                let message = { 'msg': "Product deleted from cart successfully" }
                dispatch('notification/success', message, { root: true })
            } else if (response.status == 201) {
                let message = { 'msg': "Failed to delete Product from cart" }
                dispatch('notification/error', message, { root: true })
            }
        }).catch(() => {
            commit('SET_SAVE_STATUS', false)
            let message = { 'msg': data.name + ' deleting failed' }
            dispatch('notification/error', message, { root: true })
            dispatch('fetchCart')
        })
    },

    // transfer items
    send({ dispatch, commit }, data) {
        commit('SET_SAVE_STATUS', true)
        axios.post(`stock_transfer`, data).then(response => {
            commit('SET_SAVE_STATUS', false)
            dispatch('fetchCart')
            if (response.status == 200) {
                let message = { 'msg': "Stock Sent successfully" }
                dispatch('notification/success', message, { root: true })
            } else if (response.status == 201) {
                let message = { 'msg': response.data.message }
                dispatch('notification/error', message, { root: true })
            }
        }).catch(() => {
            commit('SET_SAVE_STATUS', false)
            let message = { 'msg': "Failed to Transfer Items" }
            dispatch('notification/error', message, { root: true })
        })
    },

    // Receive Stock
    Receive({ dispatch, commit }, data) {
        commit('SET_SAVE_STATUS', true)
        axios.put(`receive_stock/${data.id}`, data).then(response => {
            commit('SET_SAVE_STATUS', false)
            dispatch('fetchStockTransfers', data.filterTransfers)
            if (response.status == 200) {
                let message = { 'msg': "Stock Received successfully" }
                dispatch('notification/success', message, { root: true })
            } else if (response.status == 201) {
                let message = { 'msg': response.data.message }
                dispatch('notification/error', message, { root: true })
            }
        }).catch(() => {
            commit('SET_SAVE_STATUS', false)
            let message = { 'msg': "Failed to Receive Stock" }
            dispatch('notification/error', message, { root: true })
        })
    },
    // Receive ends

    // start direct
    addToDirectCart({ dispatch, commit }, data) {
        commit('SET_SAVE_STATUS', true)
        axios.post('direct_transfer_cart', data).then(response => {
            commit('SET_SAVE_STATUS', false)
            dispatch('fetchDirectCart')
            if (response.status == 201) {
                let message = { 'msg': response.data.message }
                dispatch('notification/error', message, { root: true })
            }
        }).catch(() => {
            commit('SET_SAVE_STATUS', false)
            let message = { 'msg': "Failed to add Product to Cart" }
            dispatch('notification/error', message, { root: true })
        })
    },

    editDirectCart({ dispatch, commit }, data) {
        commit('SET_SAVE_STATUS', true)
        axios.put(`direct_transfer_cart/${data.id}`, data).then(response => {
            commit('SET_SAVE_STATUS', false)
            dispatch('fetchDirectCart')
            if (response.status == 200) {
                let message = { 'msg': "Product edited successfully" }
                dispatch('notification/success', message, { root: true })
            } else if (response.status == 201) {
                let message = { 'msg': "Failed to edit Product" }
                dispatch('notification/error', message, { root: true })
            }
        }).catch(() => {
            commit('SET_SAVE_STATUS', false)
            let message = { 'msg': "Failed to edit Product" }
            dispatch('notification/error', message, { root: true })
        })
    },

    deleteDirectCart({ dispatch, commit }, data) {
        commit('SET_SAVE_STATUS', true)
        axios.delete(`direct_transfer_cart/${data.id}`).then(response => {
            commit('SET_SAVE_STATUS', false)
            dispatch('fetchDirectCart')
            if (response.status == 200) {
                let message = { 'msg': "Product deleted from cart successfully" }
                dispatch('notification/success', message, { root: true })
            } else if (response.status == 201) {
                let message = { 'msg': "Failed to delete Product from cart" }
                dispatch('notification/error', message, { root: true })
            }
        }).catch(() => {
            commit('SET_SAVE_STATUS', false)
            let message = { 'msg': data.name + ' deleting failed' }
            dispatch('notification/error', message, { root: true })
            dispatch('fetchDirectCart')
        })
    },
    sendDirect({ dispatch, commit }, data) {
        commit('SET_SAVE_STATUS', true)
        axios.post(`direct_transfer`, data).then(response => {
            commit('SET_SAVE_STATUS', false)
            dispatch('fetchDirectCart')
            if (response.status == 200) {
                let message = { 'msg': "Stock Transferred successfully" }
                dispatch('notification/success', message, { root: true })
            } else if (response.status == 201) {
                let message = { 'msg': "Failed to Transfer" }
                dispatch('notification/error', message, { root: true })
            }
        }).catch(() => {
            commit('SET_SAVE_STATUS', false)
            let message = { 'msg': "Failed to Transfer Items" }
            dispatch('notification/error', message, { root: true })
        })
    },
    // end Direct

    fetchCart({ commit }) {
        axios.get('stock_transfer_cart').then(response => {
            commit('SET_STOCK_TRANSFER_CART', response.data)
        })
    },
    fetchStockTransfers({ commit, dispatch }, payload) {
        commit('SET_FILTER_STATUS', true);

        let apiPayload = { ...payload };

            apiPayload.page = payload.page ?? 1;
            apiPayload.per_page = payload.per_page ?? 50;
       
        axios.post('fetch_stocktransfer', apiPayload).then(response => {
            commit('SET_STOCK_TRANSFERS', response.data);
            commit('SET_FILTER_STATUS', false);
        }).catch((error) => {
            commit('SET_STOCK_TRANSFERS', { data: [], meta:{}, summary: {} });
            commit('SET_FILTER_STATUS', false);
            let errorMsg = 'Failed to load stock transfers.';
            if (error.response && error.response.data && error.response.data.message) {
                errorMsg = error.response.data.message;
            }
            dispatch('notification/error', { msg: errorMsg }, { root: true });
        });
    },
    fetchStockTransferDetails({ commit },id) {
        commit('SET_FILTER_STATUS', true)
        axios.get(`stock_transfer/${id}`).then(response => {
            commit('SET_FILTER_STATUS', false)
            commit('SET_STOCK_TRANSFERDETAILS', response.data)
        })
    },
    fetchStockTransfersDetails({ commit, dispatch }, payload) {
        // commit('SET_FILTER_STATUS', true,)
        // axios.post('stocktransfer_details',payload).then(response => {
        //     commit('SET_FILTER_STATUS', false)
        //     commit('SET_STOCK_TRANSFERSDETAILS', response.data)
        // })
         commit('SET_FILTER_STATUS', true);

        const apiPayload = {
            page: payload.page ?? 1,
            per_page: payload.per_page ?? 50,
            dateto: payload.dateto ?? '',
            datefrom: payload.datefrom ?? '',
            product: payload.product ?? '',
            branch_id: payload.branch_id ?? 0
        };


        axios.post('stocktransfer_details', apiPayload).then(response => {
            commit('SET_STOCK_TRANSFERSDETAILS', response.data);
            commit('SET_FILTER_STATUS', false);
        }).catch((error) => {
            commit('SET_STOCK_TRANSFERSDETAILS', { 
                data: [], 
                meta: {}, 
                summary: { totalStockValue: 0 } 
            });
            commit('SET_FILTER_STATUS', false);
            let errorMsg = 'Failed to load stock transfers details data.';
            if (error.response && error.response.data && error.response.data.message) {
                errorMsg = error.response.data.message;
            }
            dispatch('notification/error', { msg: errorMsg }, { root: true });
        });
    },

    fetchStockTransfersDetailsData({ commit, dispatch }, payload = {}) {
        commit('SET_FILTER_STATUS', true);

        const apiPayload = {
            page: payload.page ?? 1,
            per_page: payload.per_page ?? 50,
            dateto: payload.dateto ?? '',
            datefrom: payload.datefrom ?? '',
            product: payload.product ?? '',
            branch_id: payload.branch_id ?? 0
        };

        commit('SET_CURRENT_STOCK_TRANSFERSDETAILS_FILTERS', apiPayload);

        axios.post('stocktransfer_details', apiPayload).then(response => {
            commit('SET_STOCK_TRANSFERSDETAILS_DATA', response.data);
            commit('SET_FILTER_STATUS', false);
        }).catch((error) => {
            commit('SET_STOCK_TRANSFERSDETAILS_DATA', { 
                data: [], 
                meta: {}, 
                summary: { totalStockValue: 0 } 
            });
            commit('SET_FILTER_STATUS', false);
            let errorMsg = 'Failed to load stock transfers details data.';
            if (error.response && error.response.data && error.response.data.message) {
                errorMsg = error.response.data.message;
            }
            dispatch('notification/error', { msg: errorMsg }, { root: true });
        });
    },
    fetchDirectCart({ commit }) {
        axios.get('direct_transfer_cart').then(response => {
            commit('SET_DIRECT_TRANSFER_CART', response.data)
        })
    },

};
